(function () {
  'use strict';

  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var currentEl = root.querySelector('[data-gallery-current]');
    var main = root.querySelector('[data-gallery-main]');

    if (!track || slides.length === 0) return;

    var index = 0;
    var total = slides.length;

    function goTo(newIndex) {
      index = (newIndex + total) % total;
      track.style.transform = 'translateX(-' + index * 100 + '%)';

      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });

      if (currentEl) currentEl.textContent = index + 1;

      var activeThumb = thumbs[index];
      if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

      root.setAttribute('data-index', index);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goTo(index - 1);
      if (e.key === 'ArrowRight') goTo(index + 1);
    });

    // Swipe support for touch devices
    if (main) {
      var startX = 0;
      var deltaX = 0;
      var isDragging = false;

      main.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      main.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });

      main.addEventListener('touchend', function () {
        if (!isDragging) return;
        isDragging = false;
        if (Math.abs(deltaX) > 40) {
          if (deltaX < 0) goTo(index + 1);
          else goTo(index - 1);
        }
        deltaX = 0;
      });
    }

    goTo(0);
  }

  function initAll() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var gallery = e.target.querySelector('[data-product-gallery]');
    if (gallery) initGallery(gallery);
  });
})();